<template>
  <div>
    <div v-if="inDingTalk" class="text-center padding-lg">登录中...</div>
    <div v-else class="text-center padding-lg">请在钉钉中访问</div>
  </div>
</template>

<script>
  import * as dd from 'dingtalk-jsapi/entry/union';
  import showPreloader from 'dingtalk-jsapi/api/device/notification/showPreloader';
  import hidePreloader from 'dingtalk-jsapi/api/device/notification/hidePreloader';
  import requestAuthCode from 'dingtalk-jsapi/api/runtime/permission/requestAuthCode';
  import { dingTalkLogin } from '@/api/dingtalk'
  import { Dialog  } from 'vant';

  export default {
    name: 'login-dingtalk',
    data () {
      return {
        inDingTalk: dd.env.platform != 'notInDingTalk'
      }
    },
    methods: {

    },
    mounted() {
      const vm = this

      if (this.inDingTalk) {
        dd.ready(function() {
          showPreloader({
            text: '登录中...'
          })

          // 获取免登授权码
          requestAuthCode({
            corpId: vm.$route.query.corpId,
            onSuccess: function (info) {
              const code = info.code

              // 钉钉登录
              dingTalkLogin(code).then(res => {
                hidePreloader()
                const data = res.data
                if (data.code == 0) {
                  vm.$router.replace('/set-token?token='+ data.token)
                } else if (data.code == 1001) {
                  // 没有关联帐号，去注册账号
                  vm.$router.replace('/register?ddUserId='+ data.ddUserId)
                } else {
                  Dialog.alert({
                    title: '获取钉钉用户ID失败',
                    message: data.msg
                  })
                }
              })
            },
            onFail : function(err) {
              hidePreloader()
              Dialog.alert({
                title: '获取免登授权码失败，请刷新重试',
                message: JSON.stringify(err)
              })
            }
          })
        })

        dd.error(function(error){
          Dialog.alert({
            title: '钉钉配置错误',
            message: JSON.stringify(error)
          })
        })
      } else {
        Dialog.alert({
          title: '请在钉钉中访问'
        })
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
